export default __webpack_public_path__ + "static/media/paula_figueroa.db8d66d7.jpg";